import { render, staticRenderFns } from "./quoteSet.vue?vue&type=template&id=681f77c2&scoped=true"
import script from "./quoteSet.vue?vue&type=script&lang=js"
export * from "./quoteSet.vue?vue&type=script&lang=js"
import style0 from "./quoteSet.vue?vue&type=style&index=0&id=681f77c2&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "681f77c2",
  null
  
)

export default component.exports